export default __webpack_public_path__ + "static/media/basiercirclemono-regular-webfont.c1093c53.woff2";